export default __webpack_public_path__ + "static/media/kalah.96306a16.PNG";